<div class="loader-parent" *ngIf="showBigLoader">
    <div class="loader big"></div>
</div>
<!-- app loader -->
<app-loader></app-loader>

<!-- main application section -->
<div *ngIf="isValidToken && !showBigLoader">
    
    <!-- show on Sucess page -->
    <div *ngIf="!errorMessage">
        <div class="form-container" *ngIf="!showVerifyBox && !showPasswordPage && !showSucessPage">
            <div class="inner-container-wrapper">
                <div class="titletext">
                    {{'RESET_PASSWORD.TITLE_CNF_PASS' | translate}}
                </div>
                <p class="peratext pt48"> {{'RESET_PASSWORD.LABEL_SMS_CODE_SENT_TO_MOBILE' | translate}}  {{userInfo.userMobile ? userInfo.userMobile : '-'}} </p>
                <div class="pt48">
                    <button class="cp-btn cp-btn-ternary" (click)="createOTP(false)"> {{'RESET_PASSWORD.VERIFY_TOKEN.BTN_RECEIVE_OTP_CODE' | translate}} </button>
                </div>
            </div>
        </div>
    
        <div class="form-container" *ngIf="showVerifyBox">
            <!-- <cp-otp-verify [counter]="counter" [userInfo]="userInfo" [otpExpireFlag]="otpExpireFlag" (resendOtpEmitter)="resendOtp($event)"
            [isResendBtn]="isResendBtn" (failedReceioveOtpEmitter)="failedReceioveOtp()" (phoneVerifiedEmitter)="phoneVerified($event)"></cp-otp-verify> -->

            <authentication-popup
            [authData]="authData"
            [isOTPFailed]="isTimeOutHappened"
            [additionalData]="''"
            (otpSent)="detectLocation()"
            (codeVerified)="verifyOtp($event)"
            (popupClosed)="authPopUpback()"
          ></authentication-popup>
    
        </div>
    
        <div class="form-container" *ngIf="!showVerifyBox && showPasswordPage">
            <cp-update-password (tokenExpired)="onExpireToken($event)"></cp-update-password>
        </div>
        
        <div class="form-container" *ngIf="showSucessPage">
            <sucess-page></sucess-page>
        </div>
    </div>
    
    <!-- show on Error Page -->
    <div *ngIf="errorMessage">
        <div class="inner-container-wrapper">
            <div class="titletext error-msg">
                {{errorMessage}}
            </div>
            <div class="pt48">
                <button class="cp-btn cp-btn-primary" (click)="helperService.goToOnlineBankingApp()"> {{'RESET_PASSWORD.BTN_RESTORE_PASSWORD' | translate}}</button>
            </div>
        </div>
    </div>
    

</div>

<!-- show in case of token expire -->
<div *ngIf="!isValidToken">
    <cp-token-verification-failed></cp-token-verification-failed>
</div>